import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import RestaurantIcon from '@/assets/icons/restaurant-white.svg?react';
import { ServiceReservationGuide } from '@/components/ServiceReservationGuide';
import { useAuth } from '@/contexts/AuthContext';

export function DinnerAlreadyReservedGuide() {
    const navigate = useNavigate();
    const { user, checkAuth } = useAuth();
    const reservation = user?.todayDinnerReservation;

    useEffect(() => {
        let isMounted = true;

        const verifyReservation = async () => {
            const refreshedUser = await checkAuth({ showLoading: false });

            if (!isMounted) {
                return;
            }

            if (refreshedUser?.serviceAccess?.dinnerEnabled === false) {
                navigate('/dinner/access-restricted', { replace: true });
                return;
            }

            if (!refreshedUser?.todayDinnerReservation) {
                navigate('/dinner', { replace: true });
            }
        };

        void verifyReservation();

        return () => {
            isMounted = false;
        };
    }, [checkAuth, navigate]);

    return (
        <ServiceReservationGuide
            icon={<RestaurantIcon className="icon-svg" />}
            title="석식 신청 안내"
            description={
                <>
                    오늘 이미 석식 신청이 있어 추가 신청을 진행할 수 없습니다.<br />
                    신청 시간 변경을 원하시면, '예약 내역 확인' 에서 기존 신청 취소 후 다시 시도해주세요.
                </>
            }
            detailLabel="오늘 신청한 석식 시간"
            detailValue={reservation ? reservation.dinnerTime.substring(0, 5) : '-'}
            iconBackgroundColor="#F59E0B"
        />
    );
}
